{
  "dirty": false,
  "raw": "b0c261a",
  "hash": "b0c261a",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "b0c261a",
  "semverString": null,
  "buildDate": "2026-04-21T13:40:24.702Z"
}